import { fetcher } from '@commenda/utils';

import type {
  IFilingsAuditorBulkRunResponse,
  IFilingsAuditorBulkRunResultView,
  IFilingsAuditorMutationResult,
} from './types';

export async function submitFilingsAuditorRunBulk(
  serviceRequestIds: string[],
  force = false
): Promise<IFilingsAuditorMutationResult<IFilingsAuditorBulkRunResultView[]>> {
  try {
    const response = await fetcher('agent-platform/filings-auditor/runs/bulk', {
      method: 'POST',
      body: { serviceRequestIds, force },
    });
    if (!response.ok)
      return { success: false, error: 'Failed to start audit runs.' };
    const data: IFilingsAuditorBulkRunResponse = await response.json();
    return { success: true, data: data.results };
  } catch (error) {
    return {
      success: false,
      error:
        error instanceof Error ? error.message : 'Failed to start audit runs.',
    };
  }
}
